import { WifiOff } from "lucide-react";
import useOnlineStatus from "@/hooks/useOnlineStatus";

/**
 * Lightweight, non-intrusive "you're offline" indicator for the public
 * site. Renders nothing while online; connectivity returning removes it
 * automatically via the online/offline browser events (useOnlineStatus).
 */
export default function OfflineIndicator() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      data-testid="public-offline-indicator"
      className="sticky top-0 z-[60] bg-slate-900 text-white text-xs text-center py-1.5 px-3"
    >
      <span className="inline-flex items-center gap-1.5">
        <WifiOff className="w-3.5 h-3.5" aria-hidden="true" />
        You're offline: some ConfirmPH features are unavailable.
      </span>
    </div>
  );
}
